import { VisitaModel } from './visita.model';

export class AgendaModel {

  public correo: string;
  public empresa: string;
  public nombreUsuario: string;
  public numeroDocumentoUsuario: string;
  public tipoDocumentoUsuario: string;
  public visitas: VisitaModel[];
  public estado?: string;
  public fechaInicioAgendada?: string;
  public placa?: string;
  public otro?: string;
  public tipoVehiculo?: string;
  public numeroDocumentoUsuarioAutorizador?: string;
  public tipoDocumentoUsuarioAutorizador?: string;
  public numeroDocumentoUsuarioAnterior?: string;
  public tipoDocumentoUsuarioAnterior?: string;
  public tipoFuncionario?: string;
  public editar?: boolean;
  public tipoVisitante?: string;
  public primerNombre?: string;
  public segundoNombre?: string;
  public primerApellido?: string;
  public segundoApellido?: string;

  public tipoVisita?: string = '';
  
  public telefono?: string;
  public motivoIngresoComo?: string;
  public rh?: string;
  public eps?: string;
  public arl?: string;
  public nombreContactoEmergencia?: string;
  public telefonoContactoEmergencia?: string;
  public alergiasMedicamentos?: string;


  constructor(
    correo: string,
    empresa: string,
    nombreUsuario: string,
    numeroDocumentoUsuario: string,
    tipoDocumentoUsuario: string,
    visitas: VisitaModel[],
    estado?: string,
    fechaInicioAgendada?: string,
    placa?: string,
    otro?: string,
    tipoVehiculo?: string,
    numeroDocumentoUsuarioAutorizador?: string,
    tipoDocumentoUsuarioAutorizador?: string,
    tipoFuncionario?: string,
    editar?: boolean
  ) {

    this.correo = correo;
    this.empresa = empresa;
    this.nombreUsuario = nombreUsuario;
    this.numeroDocumentoUsuario = numeroDocumentoUsuario;
    this.tipoDocumentoUsuario = tipoDocumentoUsuario;
    this.visitas = visitas;
    this.estado = estado;
    this.fechaInicioAgendada = fechaInicioAgendada;
    this.placa = placa;
    this.otro = otro;
    this.tipoVehiculo = tipoVehiculo;
    this.numeroDocumentoUsuarioAutorizador = numeroDocumentoUsuarioAutorizador;
    this.tipoDocumentoUsuarioAutorizador = tipoDocumentoUsuarioAutorizador;
    this.tipoFuncionario = tipoFuncionario;
    this.editar = editar;
	this.otro = otro;

  }


}
